import { PartyService } from 'src/app/services/api/party/party.service';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { ActivatedRoute, Params, Router } from '@angular/router';
import { ProductService } from 'src/app/services/api/product/product.service';
import { Product } from 'src/app/models/interface/product/product';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { Subscription } from 'rxjs';
import { ProductDetailService } from './product-detail.service';
import { NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit, OnDestroy {

  item: Product;
  params: any;
  isps: any[];

  private id: string;
  private subscriptions = new Subscription();

  constructor(private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private breadcrumbsService: BreadcrumbsService,
    private productDetailService: ProductDetailService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private partyService: PartyService,
    private router: Router) {

  }

  ngOnInit() {
    this.subscriptions.add(this.productDetailService.reload$.subscribe(() => this.loadData()));

    this.subscriptions.add(this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.params = params;
      this.id = params.id;

      this.loadData();

      this.breadcrumbsService.sendBreadcrumbs(
        {
          breadcrumbs:
            [
              { title: 'Productos', url: 'provision/products/search' },
              { title: 'Detalle de producto', url: `provision/products/detail`, params: { id: params.id } }
            ]
        }
      );
    }));
  }

  private loadData() {
    this.productService.getProduct(this.id).subscribe(
      (data) => {
        this.item = data;
        this.partyService.getCustomers().subscribe(
          (data) => {
            this.isps = data;
          }
        )
      },
      (error) => {
        if (error.status === 403) {
          this.notificationsService.showNotification(this.translateService.instant('ERRORS.FORBIDDEN'));
          this.router.navigate(['/', '403']);
        }
      }
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
